module.exports = __webpack_public_path__ + "img/bre3.b6be88d3.png";